import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "../../../../../../../../securities/static/securities/ts/features/module-upsell/module-upsell.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = a0 => ({ "disabled": a0 });
const _c1 = () => ["popover"];
function EsgHoldingsTableComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipClasses", i0.ɵɵpureFunction0(4, _c1))("tooltipHtml", true)("tooltipTitle", ctx_r1.MP_TOOLTIP);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function EsgHoldingsTableComponent_td_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 15);
    i0.ɵɵtext(1, " Fund ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3, "Weight ");
    i0.ɵɵelementEnd();
} }
function EsgHoldingsTableComponent_ng_template_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 15);
    i0.ɵɵtext(1, "Target ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3, "Weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 15);
    i0.ɵɵtext(5, "Current ");
    i0.ɵɵelement(6, "br");
    i0.ɵɵtext(7, "Weight");
    i0.ɵɵelementEnd();
} }
function EsgHoldingsTableComponent_tr_45_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, holding_r3.weighting, "1.1-1"), "% ");
} }
function EsgHoldingsTableComponent_tr_45_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 21);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 2, holding_r3.target_weighting, "1.1-1"), "%");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(5, 5, holding_r3.current_weighting, "1.1-1"), "%");
} }
function EsgHoldingsTableComponent_tr_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EsgHoldingsTableComponent_tr_45_td_3_Template, 3, 4, "td", 20)(4, EsgHoldingsTableComponent_tr_45_ng_template_4_Template, 6, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(6, "td", 21);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 21);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 21);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td", 21);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td", 21);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "number");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const holding_r3 = ctx.$implicit;
    const MPWeights_r4 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r3.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.securityType == "fund")("ngIfElse", MPWeights_r4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(holding_r3.esg_rating || "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 8, holding_r3.esg_score, "1.2-2") || "--");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 11, holding_r3.esg_environmental_score, "1.2-2") || "--");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(16, 14, holding_r3.esg_social_score, "1.2-2") || "--");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(19, 17, holding_r3.esg_governance_score, "1.2-2") || "--");
} }
export class EsgHoldingsTableComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.MP_TOOLTIP = "Portfolio-level aggregated ESG data points are calculated using the holdings' current weights. " +
            "There's a 65% data coverage threshold requirement for the data point's calculation.";
        this.currentPage = 1;
        this.holdings = [];
        this.moduleTitle = '';
        this.pages = [];
        this.securityType = '';
        this.moduleTitle = this.eltRef.nativeElement.getAttribute('moduleTitle');
        this.securityType = this.eltRef.nativeElement.getAttribute('securityType');
        const holdingsData = this.eltRef.nativeElement.getAttribute('holdingsData');
        this.pages = JSON.parse(holdingsData);
        this.setPage(1);
    }
    setPage(page) {
        if (page >= 1 && page <= this.pages.length) {
            this.currentPage = page;
            this.holdings = this.pages[page - 1];
        }
    }
}
EsgHoldingsTableComponent.ɵfac = function EsgHoldingsTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EsgHoldingsTableComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
EsgHoldingsTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EsgHoldingsTableComponent, selectors: [["ycn-esg-holdings-table"]], standalone: false, decls: 47, vars: 12, consts: [["MPWeightHeaders", ""], ["MPWeights", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], ["ycnTooltip", "", "class", "btn btn-xs btn-circle btn-transparent btn-esg-help", 3, "tooltipClasses", "tooltipHtml", "tooltipTitle", 4, "ngIf"], [1, "panel-actions"], [1, "panel-action", "panel-pagination"], [1, "panel-pagination-content"], [1, "divider-vertical"], [1, "btn", "btn-secondary", 3, "click", "ngClass"], [1, "panel-content", 2, "min-height", "200px"], [1, "table", "table-fixed"], [1, "text-thin", "col-3"], ["class", "text-thin text-right", 4, "ngIf", "ngIfElse"], [1, "text-thin", "text-right"], [4, "ngFor", "ngForOf"], [3, "title"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-esg-help", 3, "tooltipClasses", "tooltipHtml", "tooltipTitle"], ["ycnIcon", "", 3, "name"], ["class", "text-right", 4, "ngIf", "ngIfElse"], [1, "text-right"]], template: function EsgHoldingsTableComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "h3", 4);
        i0.ɵɵtext(3);
        i0.ɵɵtemplate(4, EsgHoldingsTableComponent_div_4_Template, 2, 5, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 6)(6, "div", 7)(7, "div", 8);
        i0.ɵɵelement(8, "div", 9);
        i0.ɵɵelementStart(9, "div", 10);
        i0.ɵɵlistener("click", function EsgHoldingsTableComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setPage(ctx.currentPage - 1)); });
        i0.ɵɵtext(10, " Prev ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "div", 9);
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵlistener("click", function EsgHoldingsTableComponent_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setPage(ctx.currentPage + 1)); });
        i0.ɵɵtext(13, " Next ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 9);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(15, "div", 11)(16, "table", 12)(17, "thead")(18, "tr")(19, "td", 13);
        i0.ɵɵtext(20, "Holding Name");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, EsgHoldingsTableComponent_td_21_Template, 4, 0, "td", 14)(22, EsgHoldingsTableComponent_ng_template_22_Template, 8, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(24, "td", 15);
        i0.ɵɵtext(25, "ESG ");
        i0.ɵɵelement(26, "br");
        i0.ɵɵtext(27, "Rating");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "td", 15);
        i0.ɵɵtext(29, "ESG ");
        i0.ɵɵelement(30, "br");
        i0.ɵɵtext(31, "Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "td", 15);
        i0.ɵɵtext(33, "Env...tal ");
        i0.ɵɵelement(34, "br");
        i0.ɵɵtext(35, "Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "td", 15);
        i0.ɵɵtext(37, "Social ");
        i0.ɵɵelement(38, "br");
        i0.ɵɵtext(39, "Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "td", 15);
        i0.ɵɵtext(41, "Gov...nce ");
        i0.ɵɵelement(42, "br");
        i0.ɵɵtext(43, "Score");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(44, "tbody");
        i0.ɵɵtemplate(45, EsgHoldingsTableComponent_tr_45_Template, 20, 20, "tr", 16);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(46, "ycn-module-upsell", 17);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const MPWeightHeaders_r5 = i0.ɵɵreference(23);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.moduleTitle, "\u00A0 ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.securityType == "model_portfolio");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx.currentPage == 1));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, ctx.currentPage == ctx.pages.length));
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.securityType == "fund")("ngIfElse", MPWeightHeaders_r5);
        i0.ɵɵadvance(24);
        i0.ɵɵproperty("ngForOf", ctx.holdings);
        i0.ɵɵadvance();
        i0.ɵɵproperty("title", ctx.moduleTitle);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.IconDirective, i3.ModuleUpsellComponent, i4.TooltipDirective, i1.DecimalPipe], encapsulation: 2 });
